var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntakeImageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.695814 20.4121L0.671814 20.4361C0.347814 19.7281 0.143814 18.9241 0.0598145 18.0361C0.143814 18.9121 0.371814 19.7041 0.695814 20.4121Z",
    fill: "#212A37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.40019 10.0562C9.97757 10.0562 11.2562 8.77755 11.2562 7.20024C11.2562 5.62291 9.97757 4.34424 8.40019 4.34424C6.82286 4.34424 5.54419 5.62291 5.54419 7.20024C5.54419 8.77755 6.82286 10.0562 8.40019 10.0562Z",
    fill: "#212A37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.028 0H6.972C2.604 0 0 2.604 0 6.972V17.028C0 18.336 0.228 19.476 0.672 20.436C1.704 22.716 3.912 24 6.972 24H17.028C21.396 24 24 21.396 24 17.028V14.28V6.972C24 2.604 21.396 0 17.028 0ZM22.044 12.6C21.108 11.796 19.596 11.796 18.66 12.6L13.668 16.884C12.732 17.688 11.22 17.688 10.284 16.884L9.876 16.548C9.024 15.804 7.668 15.732 6.708 16.38L2.22 19.392C1.956 18.72 1.8 17.94 1.8 17.028V6.972C1.8 3.588 3.588 1.8 6.972 1.8H17.028C20.412 1.8 22.2 3.588 22.2 6.972V12.732L22.044 12.6Z",
    fill: "#212A37"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntakeImageIcon);
export default __webpack_public_path__ + "static/media/intake-image-icon.e2024b1fbfbdbe95a715054a15087bdb.svg";
export { ForwardRef as ReactComponent };